import { Stack, Typography } from "@mui/material";

export interface TableCell2LinesProps {
  title: string;
  desc: string;
}

const TableCell2Lines: React.FC<TableCell2LinesProps> = ({ title, desc }) => {
  return (
    <Stack p={0.5}>
      <Typography fontWeight={500} sx={{ wordBreak: "break-all", wordWrap: "break-word" }}>
        {title}
      </Typography>
      <Typography color="text.secondary" variant={"body2"} sx={{ wordBreak: "break-all", wordWrap: "break-word" }}>
        {desc}
      </Typography>
    </Stack>
  );
};

export default TableCell2Lines;
